import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class AssetApi extends BaseApi {
    constructor(client) {
        super(client, '/asset');
    }

    async getInventoryLinks(id) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/inventory-links`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getParty(id) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/party`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getPartyTemplate(params = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/party-template`, { params });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async syncParty(id, body) {
        try {
            const response = await this.client.put(`${this.basePath}/${id}/party`, body);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async update(id, data) {
        try {
            const response = await this.client.put(`${this.basePath}/${id}`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async submitPendingUpdate(id) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/submit-pending-update`, {});
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getPendingUpdate(id) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/pending-update`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getPendingUpdateSummary(ids, params = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/pending-update-summary`, {
                params: { ids: ids.join(','), ...params },
            });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getPendingUpdateById(draftId) {
        try {
            const response = await this.client.get(`${this.basePath}/pending-update/${draftId}`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getWorkflowApprovalDetail(id) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/workflow-approval-detail`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getWorkflowTemplateOptions(params = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/workflow-template-options`, { params });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async stageAssetLink(id, delta) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/stage-link`, delta);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async createFilteredReportViewerSession(payload) {
        try {
            const response = await this.client.post(`${this.basePath}/report/viewer-session`, payload, {
                timeout: 180_000,
            });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }


    async exportFilteredReport(payload) {
        try {
            const response = await this.client.post(`${this.basePath}/report/pdf`, payload, {
                responseType: 'blob',
                timeout: 180_000,
            });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

}
